<template>
  <div class="card mb-4">
    <div class="card-header bg-info text-light">
      My Apps
    </div>
    <div class="card-body">
      <div v-if="this.userapps.length">
        <ul class="list-group">
          <router-link v-for="app in this.userapps" :key="app.id" class="list-group-item" tag="li" :to="app.url">
            <a :target="app.shortname === 'SKY' || app.shortname === 'SP6' ? '_blank' : ''">{{ app.name }}</a>
            <p>{{ app.description }}</p>
            <p v-if="app.shortname === 'TPM'">
              <ul class="list-group list-group-horizontal small">
                <li v-if="app.isadmin" class="list-group-item"><i class="fa fa-cog"></i>&nbsp;&nbsp;<router-link to="/apps/tpm/admin">Admin</router-link></li>
                <li v-if="app.isadmin" class="list-group-item"><i class="fa fa-file-pdf"></i>&nbsp;&nbsp;<a href="docs/TPMSetupGuide.pdf" target="_blank">Setup Guide</a></li>
                <li class="list-group-item"><i class="fa fa-file-pdf"></i>&nbsp;&nbsp;<a href="docs/TPMUserGuide.pdf" target="_blank">User Guide</a></li>
              </ul>
            </p>
            <p v-else-if="app.shortname === 'CHECKLIST'">
              <ul class="list-group list-group-horizontal small">
                <li v-if="app.isadmin" class="list-group-item"><i class="fa fa-cog"></i>&nbsp;&nbsp;<router-link to="/apps/checklist/admin">Admin</router-link></li>
                <li v-if="app.isadmin" class="list-group-item"><i class="fa fa-file"></i>&nbsp;&nbsp;<a href="docs/Checklist_AdminQuickStart.docx" target="_blank">Quick Start: Administration</a></li>
                <li class="list-group-item"><i class="fa fa-file"></i>&nbsp;&nbsp;<a href="docs/Checklist_QuickStart.docx" target="_blank">Quick Start: Basic Usage</a></li>
              </ul>
            </p>
            <p v-else-if="app.shortname === 'COMPLIANCE'">
              <ul class="list-group list-group-horizontal small">
                <li v-if="app.isadmin" class="list-group-item"><i class="fa fa-cog"></i>&nbsp;&nbsp;<router-link to="/apps/it-compliance/admin">Admin</router-link></li>
                <li v-if="app.isadmin" class="list-group-item"><i class="fa fa-file"></i>&nbsp;&nbsp;<a href="docs/Compliance_AdminQuickStart.docx" target="_blank">Quick Start: Administration</a></li>
                <li class="list-group-item"><i class="fa fa-file"></i>&nbsp;&nbsp;<a href="docs/Compliance_QuickStart.docx" target="_blank">Quick Start: Basic Usage</a></li>
              </ul>
            </p>
          </router-link>
        </ul>
      </div>
      <div v-else style="font-style: italic;">
        No apps found.
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions } from 'vuex'

export default {
  name: 'UserAppsPanel',
  methods: {
    ...mapActions('user', ['fetchUserApps'])
  },
  data: function () {
    return {
      userapps: []
    }
  },
  created () {
    let self = this
    this.fetchUserApps({ userid: null }).then((apps) => {
      self.userapps = apps
    })
  }
}

</script>
